module.exports = __webpack_public_path__ + "static/MT_Process-02.f42d9f59.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/process-icons/MT_Process-02.png
// module id = 1499
// module chunks = 214286880276331